import { parseISO } from "date-fns";

import { useTablePagination } from "components/Table/hooks";

const getResourcesSharedWithMe = ({ page, pageSize = 10 }) => {
  const query = `
            query getResourcesSharedWithMe {
                resourcesSharedWithMe(first: ${pageSize}, offset: ${
    page * pageSize
  }) {
                    edges {
                        node {
                            id
                            recipientEmail
                            status
                            createdAt
                            sharedResource {
                                templateRelease {
                                    title
                                    releaseNumber
                                }
                                sharedBy {
                                    email
                                }
                            }
                        }
                    }
                    totalCount
                    pageInfo {
                        hasNextPage
                        endCursor
                    }
                }
            }`;

  const resolver = ({ data: { resourcesSharedWithMe } }) => {
    return {
      sharedResources: resourcesSharedWithMe.edges.map(({ node }) => {
        return {
          ...node,
          resourceName: node.sharedResource.templateRelease.title,
          sharedBy: node.sharedResource.sharedBy.email,
          sharedOn: parseISO(node.createdAt),
          status: node.status,
          version: node.sharedResource.templateRelease.releaseNumber,
        };
      }),
      totalCount: resourcesSharedWithMe.totalCount,
    };
  };

  return { query, resolver };
};

const useResourcesSharedWithMe = () => {
  const {
    pageControl,
    updatePageControl,
    reloadData,
    loading,
    data,
    numOfFetches,
  } = useTablePagination(getResourcesSharedWithMe);

  return {
    pageControl: pageControl,
    updatePageControl: updatePageControl,
    initialLoading: loading && numOfFetches === 0,
    isReloading: loading && numOfFetches > 0,
    totalCount: data?.totalCount || 0,
    sharedResources: data?.sharedResources || [],
    reloadData: reloadData,
  };
};

export default useResourcesSharedWithMe;
